import { Injectable } from "@angular/core";
import { MatDialog } from "@angular/material/dialog";
import { ErrorDialogComponent } from "@modules/common/components/error-dialog/error-dialog.component";
import { ErrorDetails } from "@modules/common/models/error-details";

@Injectable({
    providedIn: 'root'
})
export class ErrorService {
    constructor(private _dialog: MatDialog) { }

    public registerError(error: ErrorDetails): void {
        this._dialog.open(ErrorDialogComponent, {
            data: error
        });
    }
}
